/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneDiagIcon32Regular = forwardRef('SendPaperplaneDiagIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.658 14.31c-1.933-1.307-1.462-4.276.78-4.92l21.919-6.305c2.078-.598 4 1.325 3.403 3.403l-6.305 21.919c-.645 2.242-3.613 2.713-4.92.78L10.53 20.31l-8.872-6Zm10.883 5.403 5.65 8.354a.75.75 0 0 0 1.342-.213l6.305-21.92a.75.75 0 0 0-.928-.927L2.99 11.31a.75.75 0 0 0-.213 1.342l8.348 5.646 5.667-5.666a1 1 0 0 1 1.414 1.414l-5.666 5.666Z" })));
});
